import { useProjectModelError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ sourceProject, project, zone, configuration }) =>
    present(
      repository
        .duplicateProject(sourceProject, project, zone)
        .then((project) =>
          repository
            .updateProjectConfiguration(project, configuration)
            .then(() => ({ project, sourceProject, configuration, zone })),
        )
        .catch((error) =>
          Promise.reject({
            error: { ...useProjectModelError, ...error },
            zone,
            project,
            sourceProject,
            configuration,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
